<template lang="pug">
#v-scoreboard
  h1
    | 大家上雲來
    em Battle
  .board
    h2
      | 今日
      |
      em TOP 15
      |
      | 挑戰者
    .tip (依今日挑戰者積分排行)
    .header
      label.number 名次
      label.name 姓名
      label.score 累積分數
    .ranking
      .number
        label(v-for='number in 15') {{ number }}
      transition-group(name='list', tag='ol')
        li(v-for='entry in ranking', :key='entry.name')
          .name(:title='entry.name') {{ entry.name.slice(0, 9) }}
          .score {{ entry.score }}
</template>

<script>
export default {
  name: 'ScoreBoard',
  sockets: {
    ranking(data) {
      this.ranking = data.ranking
    },
  },
  data() {
    return {
      ranking: [],
    }
  },
}
</script>

<style lang="sass" scoped>
@import "~@/mixin.sass"

.list-enter-active, .list-leave-active
  transition: all 1s
.list-enter, .list-leave-to
  opacity: 0
  transform: translateY(30px)
.list-move
  transition: transform 1s

#v-scoreboard
  padding: 30px 120px 45px
h1
  +font(42px, #4A4773, null, 0.4px, 900, center)
  +flex(center, center)
  margin-bottom: 35px
  &::before, &::after
    +background(url(~@/assets/plus-icon.png))
    +size(15px)
    content: ''
    display: block
  &::before
    margin-right: 30px
  &::after
    margin-left: 30px
  em
    color: #FF356C
.board
  +border(4px, #656492, 13px)
  overflow: hidden
  padding-bottom: 25px
  h2
    +font(28px, white, null, .8px, bold, center)
    background-color: #4A4773
    padding-top: 10px
    padding-bottom: 10px
    margin-bottom: 10px
    em
      color: #FF658F
  .tip
    +font(20px, #636363, null, .57px, null, center)
    margin-bottom: 25px
  .ranking
    display: flex
  .header
    +font(28px, #4A4773, null, .8px, bold, center)
    display: flex
    margin-bottom: 20px
    padding-left: 60px
    padding-right: 60px
    .number
      flex: 2
    .name
      flex: 5
      padding-left: 30px
    .score
      flex: 3
      padding-left: 30px
  .ranking
    display: flex
    padding-left: 60px
    padding-right: 60px
    .number
      flex: 2
      label
        +font(26px, #636363, 44px, 4px, bold, right)
        display: block
        flex: none
        margin-left: auto
        margin-right: auto
        width: 40px
    ol
      flex: 8
      position: relative
      &::before, &::after
        border-left: 4px solid #D8D8D8
        content: ''
        display: block
      &::before
        +position(absolute, 5px, null, 5px, 0)
      &::after
        +position(absolute, 5px, 184px, 5px)
      li
        +font(22px, #636363, 44px, 3.38px, 500)
        display: flex
        &::before
          flex: none
          content: ''
        .name
          flex: 5
          padding-left: 30px
        .score
          flex: 3
          padding-left: 30px
</style>
